import PROFILE from './info/profile'
// import LINE_SPECIAL from './info/lineSpecial'

const COLLECTION_ICONS_DIR = '/static/img/recommend/lp/common/collection_icons/'
export const colorScheme = {
  keyColor: '#F6876F',
  second: '#F6876F',
  gradStart: '#FF8282',
  gradEnd: '#FFD79B',
  baseBg: '#F6876F', // ヘッダ用のBGとして使用(指定がない場合はgradStart,gradEndを使用し標準パラメータでグラデーションを描画)
  infoBg: '',
  messBg: '',
  profileKeyColor: '',
}

const pathCommon = '/static/img/recommend/lp/common/'
const pathCounselor = '/static/img/recommend/lp/somarimone/'

const hero = {
  //pc: `${pathCounselor}top_sp_20221003.webp`,
  //sp: `${pathCounselor}top_sp_20221003.webp`,
  //fallback_pc: `${pathCounselor}top_sp_20221003.png`,
  //fallback_sp: `${pathCounselor}top_sp_20221003.png`,
  pc: `${pathCounselor}/products/newcorner_lp_head_somarimone.png`,
  sp: `${pathCounselor}/products/newcorner_lp_head_somarimone.png`,
  fallback_pc: `${pathCounselor}/products/newcorner_lp_head_somarimone.png`,
  fallback_sp: `${pathCounselor}/products/newcorner_lp_head_somarimone.png`,
  alt: 'そまり百音',
}

const about = {
  img: `${pathCounselor}about.png`,
  headline: 'そまり百音（そまりもね）とは',
  text: 'ふんわりした口調で鋭い真理を投げかける元アイドル占い師。<br>数字に興味を持ち7歳から数秘術、タロット、西洋占星術、風水などを学ぶ。アイドル時代にライブ会場などで行っていた占いが評判を呼び、占い師として本格デビュー。鑑定歴は15年。<br>こもれびのように降り注ぐ柔らかい声に包まれた本格鑑定が不思議な異空間へと導く。',
}

const floatingBanner = {
  enable: true,
  title: '<span class="name">そまり百音</span>の<span class="emphasis">ねこ風水</span>で',
  freeBtnFace: '自分を知る（無料）',
  colors: {
    background: '#fffbe3',
    baseText: colorScheme.baseBg,
    //emphasis: colorScheme.gradStart,
    emphasis: '#ffaf41',
    decos: colorScheme.second,
    //freeBtn: colorScheme.gradStart,
    freeBtn: '#ffaf41',
    freeBtnBg: 'white',
  }
}

const lineBanner = {
  bannerUrl: '/static/img/recommend/lp/banner/somarimone_line.png'
}

const menu = {
  title: 'そまり百音の<br>占いを見てみる',
}

const title = {
  //subTitle: '全81種類の鳳凰タイプで自分がわかる',
  title: 'そまり百音のねこ風水',
}

const fortuneResult = {
  lead: 'あなたのタイプは',
}

const snsShare = {
  lead: 'ねこタイプをシェアする',
}


const menuDetails = {
  colors: {
    headBg: colorScheme.baseBg,
    headColor: 'white',
    baseBg: '#fffbe3',
    baseColor: colorScheme.baseBg,
    resultBg: 'white',
  },
  contents: [
    // { icon: `${COLLECTION_ICONS_DIR}icon_collection1.png`, description: '異性はあなたのどこに魅力を感じている？' },
    // { icon: `${COLLECTION_ICONS_DIR}icon_collection2.png`, description: 'あなたの力を最大限に活かせる<br>天職とは' },
    // { icon: `${COLLECTION_ICONS_DIR}icon_collection3.png`, description: '結婚相手の職業と収入、将来性' },
    // { icon: `${COLLECTION_ICONS_DIR}icon_collection4.png`, description: 'あなたの財運を最大限に<br>活かした稼ぎ方' },
    // { icon: `${COLLECTION_ICONS_DIR}icon_collection5.png`, description: '今後ある、一生ものの出会い' },
    // { icon: `${COLLECTION_ICONS_DIR}icon_collection6.png`, description: '人生の分岐点と、そのとき<br>あなたが取るべき選択肢' },
  ],
}

export const information = {
  name: PROFILE.name, // ※互換のため残すが以降についてはprofile.nameを使用すること
  mainMethod: PROFILE.mainMethod, // ※互換のため残すが以降についてはprofile.mainMethodを使用すること
  profile: PROFILE,
  // lineSpecial: LINE_SPECIAL,
  hero,
  about,
  floatingBanner,
  lineBanner,
  menu,
  menuDetails,
  title,
  fortuneResult,
  snsShare,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/somarimone/counselorInfos.js